"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyFileExtension = void 0;
var _string = require("./type-checks/string");
var applyFileExtension = exports.applyFileExtension = function applyFileExtension(pathname) {
  var fileExtension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".html";
  if ((0, _string.isStringOfLength)(pathname) && !pathname.endsWith(fileExtension)) {
    pathname += fileExtension;
  }
  return pathname;
};